import { db } from "../../firebase";
import {
	collection,
	doc,
	query,
	addDoc,
	updateDoc,
	getDoc,
	setDoc,
	getDocs,
	orderBy,
	where,
	Timestamp,
	deleteDoc as deleteFirestoreDoc
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";

interface DataType {
	id?: string;
	audio_url?: string | URL;
	audio_file_name?: string;
	bpm?: number;
	created?: Timestamp;
	demo_exclusive_to?: string;
	internal_song_name?: string;
	is_demo_exclusive?: boolean;
	is_released?: boolean;
	key?: string;
	length?: string;
	modified?: Timestamp;
	description?: string;
	song_name?: string;
	song_status: String;
	user_id?: string; // Assuming you have a 'user' field
}

export const ViewRecords = async (currentUser: any): Promise<DataType[]> => {
	try {
		const q = query(collection(db, "catalog"), where("user_id", "==", currentUser.uid), orderBy("created", "desc"));
		const querySnapshot = await getDocs(q);
		const data: DataType[] = [];
		querySnapshot.forEach((doc) => {
			console.log("made it to forEach of cagalog");
			const docData = doc.data();
			const createdDate = getFormattedDate(docData.created);
			const modifiedDate = getFormattedDate(docData.modified);
			data.push({
				id: doc.id,
				audio_url: docData?.audio_url || "",
				bpm: docData.bpm || null,
				created: createdDate,
				demo_exclusive_to: docData.demo_exclusive_to || "",
				internal_song_name: docData.internal_song_name || "",
				is_demo_exclusive: docData.is_demo_exclusive || false,
				is_released: docData.is_released || false,
				key: docData.key || "",
				length: docData.length || "",
				modified: modifiedDate,
				notes: docData.notes || "",
				song_name: docData.song_name || "",
				song_status: docData.song_status || ""
			});
		});
		return data;
	} catch (error) {
		console.error("Error fetching catalog data:", error);
		return [];
	}
};

export const viewRecord = async (recordId: string): Promise<DataType | null> => {
	try {
		const docRef = doc(db, "catalog", recordId);
		const docSnap = await getDoc(docRef);
		if (docSnap.exists()) {
			return {
				id: docSnap.id,
				...docSnap.data()
			};
		} else {
			console.log("Error viewing song");
			return null;
		}
	} catch (error) {
		console.error("Error viewing fan: ", error);
		return null;
	}
};

export const addRecord = async (newRecord: DataType) => {
	try {
		newRecord.song_status = "New";
		return addDoc(collection(db, "catalog"), newRecord);
	} catch (error) {
		console.error("Error adding document: ", error);
	}
};

export const editRecord = async (documentId: string, updates: { [key: string]: any }) => {
	try {
		const docRef = doc(db, "catalog", documentId);
		await updateDoc(docRef, updates);
	} catch (error) {
		throw error;
	}
};

export const deleteRecord = async (documentId: string) => {
	try {
		const docRef = doc(db, "catalog", documentId);
		await deleteFirestoreDoc(docRef);
		console.log("Document successfully deleted!");
	} catch (error) {
		console.error("Error removing document: ", error);
	}
};

export const getFormattedDate = (date: Timestamp | string | undefined): string => {
	if (!date) return "";
	const dateObj = typeof date === "string" ? new Date(date) : date.toDate();
	return dateObj.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }) + " " + dateObj.toLocaleDateString("en-US");
};
